import React from "react";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";
import { createBrowserHistory } from "history";
import Movies from "./containers/Movies/Movies";
import Home from "./containers/Home/Home";
import TvShow from "./containers/Tvshow/TvShow";
import UserProfile from "./containers/UserProfile/UserProfile";
import SingleMoviePage from "./containers/SingleMoviePage/SingleMoviePage";
import SingleTvPage from "./containers/SingleTvPage/SingleTvPage";
import AppBar from "./containers/App-Bar/AppBar";
import Subscription from "./containers/UserProfile/Subscription";

const history = createBrowserHistory();

const App = () => {
  return (
    <BrowserRouter history={history}>
      <AppBar />
      <Switch location={location}>
        <Route exact path="/" component={Home} />
        <Route
          exact
          path="/movies"
          component={(props) => <Movies {...props} />}
        />
        <Route
          exact
          path="/tvshow"
          component={(props) => <TvShow {...props} />}
        />
        <Route
          exact
          path="/userprofile/:userId"
          component={(props) => <UserProfile {...props} />}
        />
        <Route
          exact
          path="/userprofile/:userId/subscription"
          component={(props) => <Subscription {...props} />}
        />
        <Route
          exact
          path="/movies/:itemName/:itemId"
          component={(props) => <SingleMoviePage {...props} />}
        />
        <Route
          exact
          path="/tvshow/:itemName/:itemId"
          component={(props) => <SingleTvPage {...props} />}
        />
        <Route component={(props) => <Home {...props} />} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
